module.exports = __webpack_public_path__ + "img/img.7d8857bd.png";